export default __webpack_public_path__ + "static/media/Aura-Egg__45.7d47459e.png";